import React from 'react';
import { cloudFilesMigrationDesktop } from 'reactApp/appHelpers/featuresHelpers/features/cloudFilesMigrationDesktop';
import { useIsWindowIntegrationSmall } from 'reactApp/hooks/useIsWindowIntegrationSmall';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { FilesMigrationStatus } from 'reactApp/ui/FilesMigrationStatus/FilesMigrationStatus';
import ContinueUpload from 'reactApp/ui/UploadBlock/ContinueUpload';
import { UploadersList } from 'reactApp/ui/UploadBlock/UploadersList/UploadersList';
import { type IUploadDropAreaProps, UploadDropArea } from 'reactApp/ui/UploadDropArea/UploadDropArea';
import { UploadListContainer } from 'reactApp/ui/UploadList/UploadList';

import styles from './UploadBlock.css';

const newUploaderFeature = !EnvironmentSelectors.isPhone();

interface IProps extends IUploadDropAreaProps {
    showDropArea: boolean;
    allowDnd: boolean;
}

export const UploadBlock = ({ showDropArea = true, allowDnd = true, ...restProps }: IProps) => {
    const isWindowIntegrationSmall = useIsWindowIntegrationSmall();

    return (
        <>
            <UploadersList className={styles.list}>
                {cloudFilesMigrationDesktop && <FilesMigrationStatus />}
                {newUploaderFeature && <UploadListContainer allowUpload={true} isWindowIntegrationSmall={isWindowIntegrationSmall} />}
            </UploadersList>

            {allowDnd && <UploadDropArea showDropArea={showDropArea} {...restProps} />}
            <ContinueUpload />
        </>
    );
};
